module.exports = __webpack_public_path__ + "media/images/icons/tick-plain-a2d9b71f06e8681736e7b1f05cd6e7ea.svg";